import { IRuntimeAppSettings } from '@model';

export const defaultApplicationSettings: IRuntimeAppSettings = {
  localization: {
    countryIdentifier: '',
    languageIdentifier: '',
  },

  primaryCurrency: {
    currencySymbol: '',
    decimalPlaces: 0,
    currencyFormat: '',
    currency: '',
  },

  secondaryCurrency: null,

  shopSettings: {
    orderLimit: 0,
  },

  callCenter: {
    isOpened: false,
    number: '',
    openingHours: '',
  },

  features: {
    benefits: false,
    pages: new Set(),
    isPrimaryCurrencyFirst: false,
    googleRetailApiUserEvents: false,
    upsellingRedesign: false,
    enableLowerZoom: false,
    enableLoyalty: false,
    enableStickyButtonsOnCart: false,
    enableStickyButtonsOnDap: false,
    enableStickyButtonsOnUpselling: false,
    disableSalePrice: false,
    enablePrzelewyPaypoNewFlowOalt: false,
    enablePlusMinusButtonsOnCart: false,
  },
  companyName: '',
  validationRules: {
    countryCode: 'US',
    shopId: 'defaultShopId',
    hasPhoneCountryCode: false,
    phonePattern: '^[0-9]{10}$',
    phoneCountryCodePattern: '^\\+1',
    phoneMask: '(000) 000-0000',
    isPhoneCountryCodePatternMandatory: false,
    zipCodePattern: '^[0-9]{5}$',
    zipCodeMask: '00000',
    dicPattern: '^[0-9A-Za-z]{8,10}$',
    hasSeparateHouseNumber: false,
    streetPattern: '^[A-Za-z0-9 ]+$',
    personalIdentificationNumberPattern: 'regex',
  },
};
